// src/features/contact/hooks/useContactForm.js
import { useState } from "react";
import { validateContactForm } from "../utils/contactValidation";

const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    category: "",
    message: "",
};

export default function useContactForm(onSubmit) {
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;

        setValues((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: null }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationErrors = validateContactForm(values);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        onSubmit(values, resetForm);
    };

    const resetForm = () => {
        setValues(initialState);
        setErrors({});
    };

    return {
        values,
        errors,
        handleChange,
        handleSubmit,
        resetForm,
    };
}
